"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Summary = exports.Main = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lib = require("react-bootstrap/lib");

var _lodash = require("lodash");

var _PropTypes = require("../PropTypes.js");

var _ColumnFiltersSection = require("./ColumnFiltersSection.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var groupIntoPairs = function groupIntoPairs(arr, f) {
  return Object.entries((0, _lodash.groupBy)(arr, f));
};

var sameIds = function sameIds(xs, ys) {
  return (0, _lodash.isEqual)(new Set(xs), new Set(ys));
};

var tryAggregateGroupings = function tryAggregateGroupings(groupings) {
  return groupIntoPairs(groupings, function (g) {
    return g[1].map(function (e) {
      return e;
    }).sort().join("");
  }).map(function (p) {
    return [p[1].map(function (g) {
      return g[0];
    }).sort().join(", "), p[1][0][1]];
  });
};

var Main = function Main(_ref) {
  var isDifferential = _ref.isDifferential,
      columnGroups = _ref.columnGroups,
      selectedColumnIds = _ref.selectedColumnIds,
      onNewSelectedColumnIds = _ref.onNewSelectedColumnIds,
      availableColumnIds = _ref.availableColumnIds,
      columnsName = _ref.columnsName;
  var oneGroupingColumnGroups = [];
  var gottaBeContrastComparisonColumnGroups = [];
  var multipleGroupingsEachCoveringAllIdsColumnGroups = [];
  var multipleGroupingsColumnGroups = [];
  columnGroups.forEach(function (group) {
    if (group.groupings.length === 1) {
      oneGroupingColumnGroups.push(group);
    } else if (group.groupings.every(function (g) {
      return sameIds(g[1], availableColumnIds);
    })) {
      if (isDifferential && group.groupings.length === 2) {
        gottaBeContrastComparisonColumnGroups.push(group);
      } else {
        multipleGroupingsEachCoveringAllIdsColumnGroups.push(group);
      }
    } else {
      multipleGroupingsColumnGroups.push(group);
    }
  });
  var multipleGroupingsAggregatedColumnGroups = multipleGroupingsColumnGroups.map(function (group) {
    return Object.assign({}, group, {
      groupings: tryAggregateGroupings(group.groupings)
    });
  });
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h5", null, "".concat(columnsName, " selected: ").concat(selectedColumnIds.length, " / ").concat(availableColumnIds.length)), /*#__PURE__*/_react["default"].createElement(_lib.ButtonGroup, null, /*#__PURE__*/_react["default"].createElement(_lib.Button, {
    bsSize: "xsmall",
    onClick: function onClick() {
      onNewSelectedColumnIds(availableColumnIds);
    },
    style: {
      textTransform: "unset",
      letterSpacing: "unset",
      height: "unset"
    }
  }, /*#__PURE__*/_react["default"].createElement(_lib.Glyphicon, {
    glyph: "plus"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      verticalAlign: "middle"
    }
  }, " Choose all")), /*#__PURE__*/_react["default"].createElement(_lib.Button, {
    bsSize: "xsmall",
    onClick: function onClick() {
      onNewSelectedColumnIds([]);
    },
    style: {
      textTransform: "unset",
      letterSpacing: "unset",
      height: "unset"
    }
  }, /*#__PURE__*/_react["default"].createElement(_lib.Glyphicon, {
    glyph: "minus"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      verticalAlign: "middle"
    }
  }, " Remove all"))), multipleGroupingsAggregatedColumnGroups.length > 0 && /*#__PURE__*/_react["default"].createElement("div", null, multipleGroupingsAggregatedColumnGroups.map(function (group) {
    return /*#__PURE__*/_react["default"].createElement(_ColumnFiltersSection.MultipleGroupingsSection, _extends({
      key: group.name,
      availableIds: availableColumnIds,
      selectedIds: selectedColumnIds,
      onNewSelectedIds: onNewSelectedColumnIds,
      readOnly: false
    }, group));
  })), gottaBeContrastComparisonColumnGroups.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: multipleGroupingsAggregatedColumnGroups.length > 0 ? "margin-top-xlarge" : ""
  }, gottaBeContrastComparisonColumnGroups.map(function (group) {
    return /*#__PURE__*/_react["default"].createElement(_ColumnFiltersSection.OneGroupingReadOnlySection, {
      key: group.name,
      name: group.name,
      availableIds: availableColumnIds,
      selectedIds: selectedColumnIds,
      text: "".concat(group.groupings[0][0], " vs ").concat(group.groupings[1][0])
    });
  })), multipleGroupingsEachCoveringAllIdsColumnGroups.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: multipleGroupingsAggregatedColumnGroups.length > 0 ? "margin-top-xlarge" : ""
  }, multipleGroupingsEachCoveringAllIdsColumnGroups.map(function (group) {
    return /*#__PURE__*/_react["default"].createElement(_ColumnFiltersSection.OneGroupingReadOnlySection, {
      key: group.name,
      name: group.name,
      availableIds: availableColumnIds,
      selectedIds: selectedColumnIds,
      text: group.groupings.map(function (g) {
        return g[0];
      }).join(", ")
    });
  })), oneGroupingColumnGroups.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: multipleGroupingsAggregatedColumnGroups.length + gottaBeContrastComparisonColumnGroups.length + multipleGroupingsEachCoveringAllIdsColumnGroups.length > 0 ? "margin-top-xlarge" : ""
  }, oneGroupingColumnGroups.map(function (group) {
    return /*#__PURE__*/_react["default"].createElement(_ColumnFiltersSection.OneGroupingReadOnlySection, {
      key: group.name,
      name: group.name,
      availableIds: availableColumnIds,
      selectedIds: selectedColumnIds,
      text: group.groupings[0][0]
    });
  })));
};

exports.Main = Main;
var ColumnCommonTypes = {
  columnGroups: _propTypes["default"].arrayOf(_propTypes["default"].shape(_PropTypes.ColumnGroupPropTypes).isRequired).isRequired,
  selectedColumnIds: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  availableColumnIds: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  columnsName: _propTypes["default"].string.isRequired
};
Main.propTypes = Object.assign({}, ColumnCommonTypes, {
  isDifferential: _propTypes["default"].bool.isRequired,
  onNewSelectedColumnIds: _propTypes["default"].func.isRequired
});

var Summary = function Summary(_ref2) {
  var columnGroups = _ref2.columnGroups,
      selectedColumnIds = _ref2.selectedColumnIds,
      availableColumnIds = _ref2.availableColumnIds;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, "Selected: ".concat(selectedColumnIds.length, " / ").concat(availableColumnIds.length)));
};

exports.Summary = Summary;
Summary.propTypes = ColumnCommonTypes;